'use client'

import { useTranslation } from '@/hooks/client/use-translation'

interface PurchaseSectionIntroProps {
  hasModels: boolean
  hasLevels: boolean
}

export const PurchaseSectionIntro = ({ hasModels, hasLevels }: PurchaseSectionIntroProps) => {
  const { t } = useTranslation()
  let instruction = t('product.purchase.intro.sellers', 'Compare sellers and the care included. Prices are per pair.')
  if (hasModels && hasLevels) {
    instruction = t(
      'product.purchase.intro',
      'Choose a model and technology level, then compare sellers and the care included. Prices are per pair.'
    )
  } else if (hasModels) {
    instruction = t(
      'product.purchase.intro.models',
      'Choose a model, then compare sellers and the care included. Prices are per pair.'
    )
  } else if (hasLevels) {
    instruction = t(
      'product.purchase.intro.levels',
      'Choose a technology level, then compare sellers and the care included. Prices are per pair.'
    )
  }
  return <p className="mt-2 text-base leading-relaxed font-light text-navy-80">{instruction}</p>
}
